import React from "react"

import { serveImageFromBunny } from "@knowit-alma/common/src/utils/helpers"

import styles from "./Image.module.scss"

const ImageResponsive = ({
  image,
  aspectRatio,
  widths = [],
  fill,
  alt,
  ariaHidden,
  forceTransparent = false,
  dominantColorEnabled = true,
  preload,
  disableLazyLoad,
}) => {
  const [sourceUrl, queryParamCharacter] = serveImageFromBunny(image?.sourceUrl)

  const aspectRatioParam = aspectRatio ? "aspect_ratio=" + aspectRatio : ""
  const aspectRatioArray = aspectRatio?.split(":")
  const fixedAspectRatio =
    aspectRatioArray?.length === 2
      ? Math.round((aspectRatioArray[1] / aspectRatioArray[0]) * 100 * 10) /
          10 +
        "%"
      : false

  const transparent =
    forceTransparent ||
    image?.hasTransparency ||
    image?.sourceUrl.includes(".png")
  const dominantColor =
    image?.dominantColor && dominantColorEnabled ? image.dominantColor : null

  const width = image?.mediaDetails?.width
  const height = image?.mediaDetails?.height

  const paddingBottom = aspectRatio
    ? fixedAspectRatio
    : image?.mediaDetails
    ? Math.round(
        (image.mediaDetails.height / image.mediaDetails.width) * 100 * 10
      ) /
        10 +
      "%"
    : "56.25%"

  const imageWidth = widths.length > 0 ? Math.max(...widths) : null
  const qualityParam = sourceUrl?.includes("svg") ? false : "quality=70"

  const settingString = [
    imageWidth ? `width=${imageWidth}` : "",
    aspectRatioParam,
    qualityParam,
  ]
    .filter(Boolean)
    .join("&")

  const url = sourceUrl
    ? `${sourceUrl}${
        settingString
          ? [queryParamCharacter, settingString].filter(Boolean).join("")
          : ""
      }`
    : sourceUrl

  const srcSetStringArray = widths.map((size) => {
    return `${sourceUrl}${queryParamCharacter}${[
      `width=${size}`,
      aspectRatioParam,
      qualityParam,
    ]
      .filter(Boolean)
      .join("&")} ${size}w`
  })

  const srcSetString =
    sourceUrl && image?.mediaDetails ? srcSetStringArray.join(", ") : null

  return (
    <div
      className={`${styles.responsiveimagecontainer} ${
        transparent ? styles.transparent : null
      } ${fill ? styles.responsiveimagecontainerfill : null}`}
      style={{
        paddingBottom: !fill && paddingBottom ? paddingBottom : "inherit",
        backgroundColor: dominantColor && !transparent ? dominantColor : null,
      }}
    >
      <img
        className={`lazyload ${preload ? "lazypreload" : ""} ${
          styles.responsiveimage
        }`}
        src={
          disableLazyLoad
            ? url
            : "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEAAAAALAAAAAABAAEAAAI="
        }
        data-src={url}
        data-srcset={srcSetString}
        {...(disableLazyLoad ? { srcSet: srcSetString } : {})}
        data-sizes={preload ? "100vw" : "auto"}
        width={width}
        height={height}
        alt={alt ? alt : image?.altText ? image.altText : ""}
        aria-hidden={ariaHidden}
        loading={preload ? "eager" : "auto"}
      />
      <noscript>
        <img
          className={styles.responsiveimage}
          src={url}
          srcset={srcSetString}
          width={width}
          height={height}
          alt={alt ? alt : image?.altText ? image.altText : ""}
          aria-hidden={ariaHidden}
          loading={preload ? "eager" : "auto"}
        />
      </noscript>
    </div>
  )
}

export default ImageResponsive
